import { Box } from '@mui/material';
import { Button, Divider, Grid } from 'ui';
import { DataConfigType, DataConfigTypeSelector } from './CreateCollectionDataConfigRoute';
import { FunctionComponent } from 'react';
import { useLocation, useRouteMatch } from 'react-router';
import AnchorV2 from 'components/AnchorV2';
import ClowncarBodyV2 from 'components/ClowncarBody';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import CollectionDataConfigsList from 'components/consumer-widget-data-configs/CollectionDataConfigsList';

const CollectionDataConfigsHomeRoute: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const match = useRouteMatch();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const dataConfigType = (searchParams.get('dataConfigType') ||
    'businessCollection') as DataConfigType;

  return (
    <div className="Content">
      <ClowncarHeaderV2 heading="Widget data configs" />
      <div className="Main">
        <ClowncarBodyV2>
          <Box marginTop={2}>
            <Grid container spacing={2}>
              <Grid item>
                <DataConfigTypeSelector type={dataConfigType} />
              </Grid>
              <Grid item>
                <Button
                  component={AnchorV2}
                  // className={classes.createButton}
                  href={`${match.path}/new?${searchParams.toString()}`}
                >
                  Create new data configuration
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Box marginBottom={2} marginTop={2}>
            <Divider />
          </Box>

          <CollectionDataConfigsList dataConfigType={dataConfigType} />
        </ClowncarBodyV2>
      </div>
    </div>
  );
};

export default CollectionDataConfigsHomeRoute;
